import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";
import Table from "../../../../../../components/Table";
import BaseListPage from "../../../../../../base/BaseListPage";
import LeaveCardPresenter from "./LeaveCardPresenter";
import GenerateLeaveCard from "../../../employeeComponent/GenerateLeaveCard";
import React from "react";
import PrintFunction from "../../../../../../components/PrintFunction";

export default class LeaveCard extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new LeaveCardPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
    this.state = {
      objects: [],
      leaveTypes: [],
      selectLeave: "",
      object: [],
      initialData: [],
      leaveCredits: "",
      objectID: "",
      count: 0,
      limit: 10,
      current: 1,
    };
    this.contractPDF = React.createRef();
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (prevState.objects !== this.state.objects) {
  //     const initialEmails = new Set(
  //       this.state.initialData.map((data) => data.type)
  //     );
  //     const newObjects = this.state.objects.filter(
  //       (data) => !initialEmails.has(data.type)
  //     );
  //     if (newObjects.length > 0) {
  //       localStorage.setItem("LeaveCredit", JSON.stringify(newObjects));
  //     }
  //   }
  // }

  getCurrent() {
    return this.props.object.id;
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    // const leave = await findObjectUseCase().execute("leave_type");
    // const selectLeave = localStorage.getItem("selectLeave");
    // const email = this.props.object.id;
    // const newObject = await findObjectUseCase().execute("leave_cred", {
    //   where: { empID: email },
    // });
    // this.setState({
    //   initialData: newObject,
    //   leaveTypes: leave,
    //   selectLeave,
    // });
  }

  getCollectionName() {
    return "leave_card";
  }

  // delete function
  // async handleDeleteData(id) {
  //   // const deletedData = await findObjectUseCase().execute("leave_cred", {
  //   //   where: { id: id },
  //   // });
  //   // const prevDelete = JSON.parse(localStorage.getItem("DeletedCredits")) || [];
  //   // const updatedDeleteData = prevDelete.concat(deletedData);
  //   // localStorage.setItem("DeletedCredits", JSON.stringify(updatedDeleteData));
  //   DialogConfirmation(id, "leave_cred", () => this.refetchData(), true);
  //   // await this.presenter.deleteObjectUseCase.execute("leave_cred", id);
  //   // this.refetchData();
  // }

  // handleObjectData(data) {
  //   sessionStorage.setItem("selectLeave", data.type);
  //   this.setState({ selectLeave: data.type, leaveCredits: data.current });
  //   this.setState({ objectID: data.id });
  // }

  async handleLeaveCreditChange(selectLeave) {
    this.setState({ objectID: "" });
    this.setState({ selectLeave });
    sessionStorage.setItem("selectLeave", selectLeave);
  }
  onChangeLeaveCredits(leaveCredits) {
    this.setState({ leaveCredits });
  }

  async handleSaveOnClick() {
    const { object } = this.props;
    const unique = await findObjectUseCase().execute("leave_cred", {
      where: { empID: object.id, type: this.state.selectLeave },
    });
    if (this.state.objectID !== "") {
      const data = {
        email: object.email,
        empID: object.id,
        type: this.state.selectLeave,
        current: this.state.leaveCredits.toString(),
        id: this.state.objectID,
      };
      await upsertUseCase().execute("leave_cred", data);
      await this.refetchData();
      await this.refetchData();
    } else {
      if (unique.length > 0) {
        this.showError("You cannot add same leave type.");
        return;
      } else {
        const data = {
          email: object.email,
          empID: object.id,
          type: this.state.selectLeave,
          current: this.state.leaveCredits.toString(),
        };
        // console.warn("DATA: ", data);
        this.setState({ selectLeave: "", leaveCredits: "" });
        await upsertUseCase().execute("leave_cred", data);
        await this.refetchData();
        await this.refetchData();
      }
    }
  }
  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }
  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { leaveTypes, objects, loading, current, limit, count } = this.state;

    return (
      <>
        <div className="m-4">
          <div className="d-none">
            <div ref={this.contractPDF} id="contractPDF">
              <GenerateLeaveCard
                object={this.props.object}
                leaveRequest={objects || []}
                yearSelected={"2025"}
              />
            </div>
          </div>
          <div className="justify-content-end d-flex mb-2">
            <button
              type="button"
              onClick={() => {
                PrintFunction(this.contractPDF.current);
              }}
              className="btn btn-primary fs-sm me-3"
            >
              Print PDF
            </button>
          </div>

          <Table
            // objectId={this.handleDeleteData.bind(this)}
            refetch={this.refetchData.bind(this)}
            // objectData={this.handleObjectData.bind(this)}
            progress={loading}
            fields={schema.fields}
            objects={objects}
            collection={schema}
            count={count}
            limit={limit}
            current={current}
            loadPagination={this.onClickPagination.bind(this)}
            // actionsList={[
            //   {
            //     label: <i class="bi bi-pencil-square" />,
            //     actionType: "object",
            //   },
            //   {
            //     label: <i className="bi bi-trash" />,
            //     actionType: "delete",
            //   },
            // ]}
            excludeFields={Object.keys(schema.fields).reduce(
              (acc, key) => {
                const options = schema.fields[key];
                if (options.read === false) {
                  acc.push(key);
                }
                switch (options._type || options.type) {
                  case "Relation":
                  case "Array":
                  case "Object":
                  case "File":
                    acc.push(key);
                    break;
                  default:
                }
                return acc;
              },
              [
                "id",
                "name",
                "email",
                "status",
                "startDate",
                "endDate",
                "withoutPay",
                "categoryType",
                "employee",
              ],
            )}
            onClickItem={this.onClickItem.bind(this)}
          />
        </div>
      </>
    );
  }
}
